import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ActiveSecurityContextStateService } from '@security/active-security/active-security-context.state-service';
import { holidayAllowanceRoutes } from '@app/admin-hub/holiday-allowances/holiday-allowance-routes';
import { adminHubAbsenceRoutes } from '@app/admin-hub/absence/absence-routes';
import { MenuItem, TopMenuItem } from '../../../../component-library/layout/menu-item/menu-interfaces';
import { SidebarMenuConfig } from '../../../../component-library/layout/sidebar/sidebar-menu.interface';

@Injectable({ providedIn: 'root' })
export class AdminHubNavigationService {
  constructor(public activeSecurity: ActiveSecurityContextStateService) {}

  getSidebarMenuConfig$(): Observable<SidebarMenuConfig> {
    return of(this.getSidebarMenuConfig());
  }

  private getSidebarMenuConfig = (): SidebarMenuConfig => {
    const sections: TopMenuItem[] = [];
    const mainItems: MenuItem[] = [];

    if (this.activeSecurity.hasOrganisationAuthorityTo('AccessAdminHub')) {
      mainItems.push({
        label: 'Calendar',
        route: adminHubAbsenceRoutes.calendar,
        icon: 'calendar-dots',
        type: 'MenuLink',
        feature: 'AdminHubCalendar'
      } as any);

      if (this.activeSecurity.hasOrganisationAuthorityTo('AccessAdminHubHolidays')) {
        mainItems.push({
          label: 'Manage holidays',
          route: holidayAllowanceRoutes.manageHolidayAllowanceEntitlements,
          icon: 'island',
          type: 'MenuLink',
          feature: 'HolidayAllowanceDashboard'
        } as any);
      }

      if (this.activeSecurity.hasOrganisationAuthorityTo('EditEmployeeSickness')) {
        mainItems.push({
          label: 'Manage absence',
          route: adminHubAbsenceRoutes.settings,
          icon: 'first-aid',
          type: 'MenuLink',
          feature: 'Settings'
        } as any);
      }
    }

    if (mainItems.length > 0) {
      sections.unshift({
        items: mainItems
      });
    }

    return {
      sections,
      bottomNavItems: this.fetchBottomNavItems()
    };
  };

  private fetchBottomNavItems = (): MenuItem[] => {
    const bottomNavItems: MenuItem[] = [];

    if (this.activeSecurity.hasOrganisationAuthorityTo('AccessAdminHub')) {
      bottomNavItems.push({
        label: 'Home',
        route: 'admin-hub/calendar',
        icon: 'house',
        feature: 'AdminHubCalendar',
        type: 'MenuLink'
      } as any);

      if (this.activeSecurity.hasOrganisationAuthorityTo('AccessAdminHubHolidays')) {
        bottomNavItems.push({
          label: 'Balances',
          route: 'admin-hub/holiday-allowances/balance',
          icon: 'island',
          feature: 'HolidayAllowanceDashboard',
          type: 'MenuLink'
        } as any);
      }
    }

    return bottomNavItems;
  };
}
